import type { PeriodBounds } from '@/lib/api/generated/model';

import { PeriodStepper } from './PeriodStepper';
import { PeriodTypeSelector } from './PeriodTypeSelector';

/**
 * The period being read and how to move it, in one row: step back and forward,
 * and choose a day, week, month or the whole history.
 *
 * Shared by both AI usage tabs (spec 224 review), so Models and Spend read periods
 * the same way and the controls stand in the same place on each.
 */
export function PeriodControls({
  period,
  earliestPeriodKey,
  onChange,
}: {
  period: PeriodBounds;
  earliestPeriodKey: string | null;
  onChange: (periodKey: string | undefined) => void;
}) {
  return (
    // On a phone the stepper and the period type each take the full width
    // (spec 277).
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 max-md:flex-col max-md:items-stretch">
      <PeriodStepper
        period={period}
        earliestPeriodKey={earliestPeriodKey}
        onChange={onChange}
      />
      <PeriodTypeSelector period={period} onChange={onChange} />
    </div>
  );
}
